<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Elderly Wellness Program" subtitle="Elderly Wellness Program"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing1 [data]="pricing"></app-pricing1> -->
        <!-- PRICING TABLE SECTION END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing2 [data]="pricing"></app-pricing2> -->
        <!-- PRICING TABLE SECTION END -->
        <div class="container pb-5">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6">
                    <div class="text-content ">
                        
                        <h5>Program Structure:</h5>
                        <p>
                            Elderly Wellness Program at Soul Space is a compassionate and engaging initiative
                            designed for elderly people or for the people above 60 years of age. Fostering the
                            physical, emotional, mental and social health of the seniors, the program aims to
                            enhance the overall wellbeing of elders, empowering them to lead fulfilling and
                            vibrant lives.
                        </p>
    
                        <h5> Key Features of the Program:</h5>
                            <p>
                            <b>Emotional and Mental Wellbeing:</b> </p>
                            <ul class="centered-list">
                           <li> Mindfulness and Relaxation - To reduce stress, foster a sense of inner peace,
                            and enhance their focus through gentle mediation and <span style="margin-left: 25px;">mindfulness exercises.</span></li>
                            <li> Memory and Cognitive Health - Customized activities and exercises to
                            improve cognitive function, memory and mental agility.</li>
                            </ul>
                        </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="about-image">
                                
    
                                <img src="assets/images/origami-fun-2023-11-27-05-14-01-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                                height: 450px;
                                width: 100%;
                                margin-bottom: 15px;
                            ">
                            </div>
                         
    
                        </div>

                <!-- Left Side: Image -->
                <!-- <div class="col-lg-12 col-md-12 m-b10">
                    <div class="image-container text-center mt-5 mb-4">
                        <img src="assets/images/origami-fun-2023-11-27-05-14-01-utc.jpg" alt="Elderly Wellness Program" class="img-fluid rounded-img shadow-img">
                    </div>
                </div> -->

                <!-- Right Side: Text Content -->
                <div class="col-lg-12 col-md-12">
                    <div class="text-content">

                            <ul class="centered-list">
                            
                            <li> Emotional Support Group - A safe and secure space to share experiences,
                            express feelings and build a community to support each <span style="margin-left: 25px;">other.</span></li>
                           <br>

                            <p> <b> Physical Health and Vitality:</b></p>
                            <li>Gentle Exercise Routines - In order to improve strength, balance and mobility
                                the program offers yoga and fitness sessions, <span style="margin-left: 25px;">stretching and low-impact
                                activities.</span></li> 
                                <li>Nutrition Guidance - The program offers easy-to-follow tips for maintaining a
                            balanced diet that supports their aging in a healthy <span style="margin-left: 25px;">manner.</span></li> 
                            <li> Health Awareness - Interactive discussions and educational sessions on
                            preventive care, chronic conditions and overall physical <span style="margin-left: 25px;">wellness.</span></li>
                            <br>
                            <p><b> Social Connections and Engagement:</b></p>
                            <li>Community Bonding - Preventing loneliness and fostering social connection
                            and interaction through games, events and activities.</li> 
                            <li> Skill-Building Workshops - Helping elderly to stay mentally and socially active
                            by exploring new interests, hobbies and skills.</li> 
                            <li> Intergenerational Engagement - Program provides an opportunity to the
                            younger generation to connect with the elders to share <span style="margin-left: 25px;">wisdom, stories and
                            companionship.</span></li>
                            <br>
                            <p><b>Holistic and Personalised Approach:</b> </p>
                            <li> Flexibility - Customized activities tailored to individual preferences ensuring
                            comfort and accessibility to all.</li>
                            <li> Wellness Beyond Health - Fostering joy, purpose, positive outlook towards life
                            through meaningful experiences and relationships.</li>
                        </ul>
                        <h5>Evidence-Based Approach:</h5>
                    <ul class="centered-list">
                    <!-- <p>
                        How We Do It:</p> -->
                       <li>Psychological Evaluations: Structured tools, behavioral observations, and
                        data-driven analysis.</li>
                        <li> Interventions: Counseling, Cognitive Behavioral Therapy (CBT), mindfulness
                        practices, and workshops.</li>
                    </ul>
                    <h5>Program Benefits:</h5>
                    <ul class="centered-list">
                    <li>
                         Physical health: Improved strength and flexibility.</li>
                         <li> Mental clarity: Reduced stress and improved focus.</li>
                        <li> Emotional resilience: Tools to handle challenges effectively.</li>
                        <li> Community support: A network of women on a shared journey.</li>
                    </ul>


                    </div>
                </div>
            </div>
        </div>



    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>